/* edge-r-howto.js: How-to page (/pages/instructions, template page.how-to). Pass 7 build (Lane 21, H5), 2026-10-05.
   Ported from the pass 6 How-to page script. No libraries. Loaded with defer by each edge-r-howto-* section;
   it runs once (guard below) and sets up every How-to section on the page, plus any the theme editor reloads.
   Motion rules: nothing on the first screen starts hidden; looping animation pauses off-screen and in hidden tabs;
   prefers-reduced-motion turns the motion off (the CSS does the rest). */
(function () {
  'use strict';
  if (window.EdgeRHowto) return;
  var d = document, de = d.documentElement;
  de.classList.add('erh-js');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var behave = reduce ? 'auto' : 'smooth';
  var NS = 'http://www.w3.org/2000/svg';
  function $(s, c) { return (c || d).querySelector(s); }
  function $$(s, c) { return [].slice.call((c || d).querySelectorAll(s)); }
  function on(el, ev, fn, opt) { if (el) el.addEventListener(ev, fn, opt); }

  /* ---------- sticky offset: the chapter bar sits under the theme's sticky header (Dawn), whatever its state ---------- */
  var erhTop = -1;
  function headerBottom() {
    var h = d.querySelector('.section-header');
    if (!h) return 0;
    var pos = getComputedStyle(h).position;
    if (pos !== 'sticky' && pos !== 'fixed') return 0;
    return Math.max(0, Math.round(h.getBoundingClientRect().bottom));
  }
  function setTop() {
    var t = headerBottom();
    if (t !== erhTop) { erhTop = t; de.style.setProperty('--erh-top', t + 'px'); }
  }
  function navH() { var n = $('.edge-r-howto nav.chapters'); return n ? n.offsetHeight : 0; }

  /* ---------- off-screen pause for looping CSS animation (each section wrapper gets .erh-off while off-screen) ---------- */
  var offIO = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { e.target.classList.toggle('erh-off', !e.isIntersecting || d.hidden); });
  }, { rootMargin: '64px 0px' }) : null;
  on(d, 'visibilitychange', function () {
    $$('.edge-r-howto').forEach(function (r) {
      if (d.hidden) r.classList.add('erh-off');
      else { var b = r.getBoundingClientRect(); r.classList.toggle('erh-off', b.bottom < -64 || b.top > window.innerHeight + 64); }
    });
  });

  /* ---------- in-page chapter links: smooth scroll to the section, under the sticky bars ---------- */
  on(d, 'click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="#how-"]');
    if (!a || !a.closest('.edge-r-howto')) return;
    var t = d.getElementById(a.getAttribute('href').slice(1));
    if (!t) return;
    e.preventDefault();
    window.scrollTo({ top: t.getBoundingClientRect().top + window.scrollY - erhTop - navH() + 1, behavior: behave });
  });

  /* ---------- reveal: elements already on screen are shown at once (never hidden); the rest rise in on scroll ---------- */
  var pending = [];
  function collect(root) {
    $$('.rv,.ico,.claim,.finish', root).forEach(function (el) { if (!el.closest('.hslide')) pending.push(el); });
    $$('.ico .d', root).forEach(function (p) { p.setAttribute('pathLength', '1'); });
  }
  function sweep(first) {
    if (!pending.length) return;
    var lim = window.innerHeight * (first ? 1 : 0.92);
    pending = pending.filter(function (el) {
      if (!el.isConnected) return false;
      if (reduce || el.getBoundingClientRect().top < lim) { el.classList.add('in'); return false; }
      return true;
    });
  }

  /* ---------- chapter position: chapter chips, progress rail, top progress bar ---------- */
  var CH = ['how-parts', 'how-holds', 'how-order', 'how-stow', 'how-uses', 'how-finish'];
  var scrollTL = false;
  try { scrollTL = window.CSS && CSS.supports('animation-timeline: scroll()'); } catch (e) {}
  var curSec = null;
  function chapterPos() {
    var nav = $('.edge-r-howto--chapters');
    if (!nav) return;
    var secs = CH.map(function (id) { return d.getElementById(id); }).filter(Boolean);
    if (!secs.length) return;
    var line = window.innerHeight * 0.45, idx = -1, frac = 0;
    var tops = secs.map(function (s) { return s.getBoundingClientRect().top; });
    for (var i = 0; i < tops.length; i++) { if (tops[i] <= line) idx = i; }
    if (idx >= 0 && idx < tops.length - 1) frac = Math.max(0, Math.min(1, (line - tops[idx]) / (tops[idx + 1] - tops[idx])));
    var id = idx >= 0 ? secs[idx].id : null;
    if (id !== curSec) {
      curSec = id;
      $$('[data-nav]', nav).forEach(function (a) { a.setAttribute('aria-current', a.getAttribute('data-nav') === id ? 'true' : 'false'); });
      secs.forEach(function (s, k) {
        var a = $('[data-rail="' + s.id + '"]', nav);
        if (!a) return;
        a.setAttribute('aria-current', k === idx ? 'true' : 'false');
        a.classList.toggle('done', k < idx);
      });
      var cur = id && $('[data-nav="' + id + '"]', nav);
      if (cur && window.innerWidth < 760) { var ol = cur.closest('ol'); ol.scrollTo({ left: cur.parentNode.offsetLeft - 16, behavior: behave }); }
    }
    var rail = $('.rail', nav);
    if (rail) rail.style.setProperty('--rp', idx < 0 ? 0 : Math.min(1, (idx + frac) / Math.max(1, secs.length - 1)));
    if (!scrollTL) {
      var pb = $('.pbar i', nav), max = de.scrollHeight - window.innerHeight;
      if (pb) pb.style.setProperty('--pg', max > 0 ? Math.min(1, window.scrollY / max) : 0);
    }
  }

  /* ================= chapter 1: part list <-> diagram, both ways ================= */
  function initParts(root) {
    var fig = $('.story-fig', root), figStage = $('.fig-stage', root), plist = $('.plist', root);
    var dg = $('.dg', root), dgCap = $('.dg-cap', root), dgZone = $('.dg-zone', root);
    if (!fig || !figStage || !plist || !dg || !dgCap) return;
    var items = $$('.plist > li', root), pbtns = items.map(function (li) { return li.querySelector('button'); });
    var hls = $$('.dg-hl', fig), hss = $$('.hs', fig), partI = -1;
    function hlKey(img) { var m = /dg-hl--(\w+)/.exec(img.className); return m ? m[1] : ''; }
    function setPart(i) {
      partI = i;
      var key = i < 0 ? 'platform' : items[i].getAttribute('data-key');
      fig.setAttribute('data-active', key);
      fig.classList.toggle('idle', i < 0);
      hls.forEach(function (h) { h.classList.toggle('on', i >= 0 && hlKey(h) === key); });
      if (dgZone) dgZone.classList.toggle('on', i >= 0 && key === 'zone');
      items.forEach(function (li, k) { var o = k === i; li.classList.toggle('open', o); pbtns[k].setAttribute('aria-expanded', o ? 'true' : 'false'); });
      var lead = true;
      hss.forEach(function (b) {
        var o = +b.getAttribute('data-go') === i;
        b.classList.toggle('lit', o); b.classList.toggle('lead', o && lead); b.setAttribute('aria-pressed', o ? 'true' : 'false');
        if (o) { lead = false; b.setAttribute('aria-current', 'true'); } else b.removeAttribute('aria-current');
      });
      if (i >= 0) {
        dgCap.querySelector('b').textContent = items[i].getAttribute('data-cap-title') || '';
        dgCap.querySelector('span').textContent = items[i].getAttribute('data-cap-line') || '';
        dgCap.classList.add('on');
      } else dgCap.classList.remove('on');
      layoutDg();
    }
    /* narrow figures: when the caption band would cover the lit dots, the drawing slides up (and if it must, eases back)
       so they clear it; unlit dots under the band fade out; the name tag stays inside the figure */
    var LOUPE_TOP = 8 / 780;
    function layoutDg() {
      var W = figStage.clientWidth, H = figStage.clientHeight;
      if (!W || !H) return;
      figStage.classList.toggle('tight', W < 300); figStage.classList.toggle('narrow', W < 420);
      var capOn = dgCap.classList.contains('on'), R = 12;
      var capTop = capOn ? H - dgCap.offsetHeight - (W < 300 ? 6 : 10) : H + 100;
      var pos = function (b) { return { x: parseFloat(b.style.left) / 100 * W, y: parseFloat(b.style.top) / 100 * H }; };
      var lit = hss.filter(function (b) { return b.classList.contains('lit'); }), maxY = 0;
      lit.forEach(function (b) { var y = pos(b).y; if (y > maxY) maxY = y; });
      var k = 1, ty = 0, artTop = LOUPE_TOP * H;
      if (lit.length && maxY + R + 6 > capTop) {
        var need = maxY + R + 6 - capTop;
        if (need <= artTop - 2) ty = -need;
        else { k = Math.max(0.6, Math.min(1, (capTop - R - 8) / (maxY - artTop))); ty = 2 - k * artTop; }
      }
      dg.style.transform = (ty || k !== 1) ? 'translateY(' + ty.toFixed(1) + 'px) scale(' + k.toFixed(3) + ')' : '';
      hss.forEach(function (b) {
        var p = pos(b), cy = ty + k * p.y, cx = W / 2 + k * (p.x - W / 2);
        b.classList.toggle('under', capOn && cy + R > capTop - 2);
        var tag = b.firstElementChild; if (!tag) return;
        var tw = tag.offsetWidth, th = tag.offsetHeight, left = cx - tw / 2, tx = 0;
        if (left < 4) tx = 4 - left; else if (left + tw > W - 4) tx = W - 4 - (left + tw);
        b.style.setProperty('--tx', (tx / k).toFixed(1) + 'px');
        if (b.getAttribute('data-go') !== '2') b.classList.toggle('below', cy - 16 - th * k < 4);
      });
    }
    if ('ResizeObserver' in window) new ResizeObserver(function () { layoutDg(); }).observe(figStage);
    else on(window, 'resize', layoutDg);
    pbtns.forEach(function (b, k) { on(b, 'click', function () { setPart(partI === k ? -1 : k); }); });
    hss.forEach(function (b) {
      on(b, 'click', function () {
        var i = +b.getAttribute('data-go'); setPart(i);
        if (window.innerWidth <= 760) {
          var r = pbtns[i].getBoundingClientRect(), fb = fig.getBoundingClientRect().bottom;
          if (r.top < fb || r.bottom > window.innerHeight) window.scrollBy({ top: r.top - fb - 8, behavior: behave });
        }
      });
    });

    setPart(-1);
  }

  /* ================= chapter 2: holds slider + angle gauge ================= */
  function initHolds(root) {
    var hv = $('.hold-view', root), htrack = $('.hold-track', root);
    if (!hv || !htrack) return;
    var slides = $$('.hslide', root), tabs = $$('.hold-tabs [role="tab"]', root);
    var hCount = $('.erh-count', root), hPrev = $('#erh-holdPrev', root), hNext = $('#erh-holdNext', root), hk = 0, HN = slides.length;
    var gReady = false, gMode = function () {};
    function holdGo(k, focusTab) {
      k = Math.max(0, Math.min(HN - 1, k)); hk = k;
      htrack.style.transform = 'translateX(' + (-100 * k) + '%)';
      slides.forEach(function (s, i) {
        var o = i === k;
        s.classList.toggle('cur', o); s.setAttribute('aria-hidden', o ? 'false' : 'true'); s.inert = !o;
        if (o) { var ic = s.querySelector('.ico'); if (ic) ic.classList.add('in'); }
      });
      tabs.forEach(function (tb, i) { tb.setAttribute('aria-selected', i === k ? 'true' : 'false'); tb.tabIndex = i === k ? 0 : -1; });
      if (focusTab && tabs[k]) tabs[k].focus();
      if (hCount) hCount.textContent = 'Hold ' + (k + 1) + ' of ' + HN;
      if (gReady) gMode(k === 0 ? 'snow' : 'ice');
      if (hPrev) hPrev.disabled = k === 0;
      if (hNext) hNext.disabled = k === HN - 1;
    }
    tabs.forEach(function (tb, i) {
      on(tb, 'click', function () { holdGo(i); });
      on(tb, 'keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight') n = hk + 1; else if (e.key === 'ArrowLeft') n = hk - 1; else if (e.key === 'Home') n = 0; else if (e.key === 'End') n = HN - 1;
        if (n !== null) { e.preventDefault(); holdGo(n, true); }
      });
    });
    on(hPrev, 'click', function () { holdGo(hk - 1); });
    on(hNext, 'click', function () { holdGo(hk + 1); });
    on(hv, 'keydown', function (e) {
      if (e.target !== hv) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); holdGo(hk + 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); holdGo(hk - 1); }
      else if (e.key === 'Home') { e.preventDefault(); holdGo(0); }
      else if (e.key === 'End') { e.preventDefault(); holdGo(HN - 1); }
    });
    var drag = false, dsx = 0, dsy = 0, ddx = 0, lock = null, pid = null;
    on(hv, 'pointerdown', function (e) { if (e.pointerType === 'mouse' && e.button !== 0) return; drag = true; dsx = e.clientX; dsy = e.clientY; ddx = 0; lock = null; pid = e.pointerId; });
    on(hv, 'pointermove', function (e) {
      if (!drag || e.pointerId !== pid) return;
      var mx = e.clientX - dsx, my = e.clientY - dsy;
      if (lock === null && (Math.abs(mx) > 8 || Math.abs(my) > 8)) {
        lock = Math.abs(mx) > Math.abs(my) ? 'x' : 'y';
        if (lock === 'x') { hv.classList.add('drag'); try { hv.setPointerCapture(pid); } catch (_) {} }
      }
      if (lock === 'x') {
        ddx = mx; var edge = (hk === 0 && ddx > 0) || (hk === HN - 1 && ddx < 0);
        htrack.style.transform = 'translateX(calc(' + (-100 * hk) + '% + ' + (edge ? ddx * 0.3 : ddx).toFixed(1) + 'px))';
        e.preventDefault();
      }
    });
    function dragEnd() {
      if (!drag) return; drag = false; hv.classList.remove('drag');
      if (lock === 'x') { var w = hv.clientWidth; if (Math.abs(ddx) > Math.min(80, w * 0.15)) holdGo(hk + (ddx < 0 ? 1 : -1)); else holdGo(hk); }
      lock = null;
    }
    on(hv, 'pointerup', dragEnd); on(hv, 'pointercancel', dragEnd);
    on(hv, 'lostpointercapture', function (e) { if (e.target === hv) dragEnd(); });

    /* hold tabs: two quick gold passes the first time the row is fully in view, so people see they're tappable */
    var tabRow = $('.hold-tabs', root);
    if (!reduce && tabRow && 'IntersectionObserver' in window) {
      var tio = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          if (!(en.isIntersecting && en.intersectionRatio >= 0.9)) return;
          tio.disconnect();
          var STEP = 420, ON = 500;
          for (var pass = 0; pass < 2; pass++) {
            tabs.forEach(function (tb, i) {
              var at = (pass * tabs.length + i) * STEP;
              setTimeout(function () { tb.classList.add('flash'); }, at);
              setTimeout(function () { tb.classList.remove('flash'); }, at + ON);
            });
          }
        });
      }, { threshold: [0, 0.9, 1], rootMargin: '-56px 0px -10% 0px' });
      tio.observe(tabRow);
    }

    /* angle gauge: the visitor drags the angle and the tray follows. Ice holds 15–35°; Snow Clearing Hold 15–50°.
       The mode follows the hold slider, or the visitor picks it. */
    var gr = $('#erh-gRange', root);
    if (gr) {
      var GMODES = {
        ice: { lo: 15, hi: 35, head: 'Hold it at 15–35°', surf: 'GLASS', edge: 'BLADE', title: 'Ice holds: blade on the glass at 15 to 35 degrees' },
        snow: { lo: 15, hi: 50, head: 'Hold it at 15–50°', surf: 'ANY VEHICLE SURFACE', edge: 'RUBBER SNOW PLOW', title: 'Snow Clearing Hold: Rubber Snow Plow at 15 to 50 degrees to the surface' }
      };
      var LO = 15, HI = 35, GMIN = +gr.min, GMAX = +gr.max;
      var gTray = $('#erh-gTray', root), gRead = $('#erh-gRead', root), gStat = $('#erh-gStat', root), gArc = $('#erh-gArc', root), gModeBtns = $$('#erh-gModes button', root);
      var gpt = function (r, deg) { var a = deg * Math.PI / 180; return (90 + r * Math.cos(a)).toFixed(1) + ',' + (200 - r * Math.sin(a)).toFixed(1); };
      var gSet = function (v) {
        v = +v; var ok = v >= LO && v <= HI, a = v * Math.PI / 180;
        gTray.style.transform = 'rotate(' + (-v) + 'deg)';
        gArc.setAttribute('d', 'M150,200 A60,60 0 0 0 ' + (90 + 60 * Math.cos(a)).toFixed(1) + ',' + (200 - 60 * Math.sin(a)).toFixed(1));
        gRead.textContent = v + '°';
        gStat.classList.toggle('ok', ok);
        gStat.textContent = ok ? 'In range: ' + LO + '–' + HI + '°' : (v < LO ? 'Too flat. Tip it up a little.' : 'Too steep. Lay it down a little.');
        gr.setAttribute('aria-valuetext', v + ' degrees, ' + (ok ? 'in range' : (v < LO ? 'too flat' : 'too steep')));
      };
      gMode = function (m) {
        var g = GMODES[m]; if (!g) return;
        LO = g.lo; HI = g.hi;
        $('#erh-gBand', root).setAttribute('d', 'M' + gpt(112, LO) + ' A112,112 0 0 0 ' + gpt(112, HI));
        $('#erh-gLoL', root).setAttribute('d', 'M90,200 L' + gpt(125, LO)); $('#erh-gHiL', root).setAttribute('d', 'M90,200 L' + gpt(125, HI));
        var lt = gpt(132, LO - 2).split(','), ht = gpt(134, HI + 3).split(',');
        var loT = $('#erh-gLoT', root), hiT = $('#erh-gHiT', root);
        loT.setAttribute('x', lt[0]); loT.setAttribute('y', lt[1]); loT.textContent = LO + '°';
        hiT.setAttribute('x', ht[0]); hiT.setAttribute('y', ht[1]); hiT.textContent = HI + '°';
        $('#erh-gSurf', root).textContent = g.surf; $('#erh-gEdge', root).textContent = g.edge;
        $('#erh-gTitle', root).textContent = g.title; $('#erh-gHead', root).textContent = g.head;
        gModeBtns.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-g') === m ? 'true' : 'false'); });
        gr.style.setProperty('--lo', ((LO - GMIN) / (GMAX - GMIN) * 100).toFixed(1) + '%');
        gr.style.setProperty('--hi', ((HI - GMIN) / (GMAX - GMIN) * 100).toFixed(1) + '%');
        gSet(gr.value);
      };
      gModeBtns.forEach(function (b) { on(b, 'click', function () { gMode(b.getAttribute('data-g')); }); });
      on(gr, 'input', function () { gSet(gr.value); });
      gMode('ice');
    }
    gReady = !!gr;
    holdGo(0);
  }

  /* ================= chapter 3: the clearing order (step player) ================= */
  function initOrder(root) {
    var stage = $('#erh-stage', root), data = $('script[data-erh-steps]', root), prog = $('#erh-progress', root);
    if (!stage || !data || !prog) return;
    var STEPS;
    try { STEPS = JSON.parse(data.textContent); } catch (e) { return; }
    if (!STEPS || !STEPS.length) return;
    var CAP = { side: root.getAttribute('data-cap-side') || '', top: root.getAttribute('data-cap-top') || '', sw: root.getAttribute('data-cap-sw') || '' };

    /* side view: zones on the 1536 x 700 side picture; grid lines at x 459 / 1044, y 187 / 350 */
    var CX = [0, 459, 1044, 1536], RY = [0, 187, 350, 592], SH = {};
    for (var r = 0; r < 3; r++) for (var c = 0; c < 3; c++) SH['r' + r + 'c' + c] = [CX[c], RY[r], CX[c + 1] - CX[c], RY[r + 1] - RY[r]];
    SH.all = [3, 3, 1530, 586];
    var ARW = {
      s1a: 'M1340,262 H560', s1b: 'M1420,440 H140',
      s2: 'M1070,170 H610 Q520,172 476,246 Q446,304 330,306 H130',
      s3: 'M1110,170 H1180 Q1250,176 1296,224 Q1330,266 1400,304'
    };
    function el(parent, tag, attrs) { var n = d.createElementNS(NS, tag); for (var k in attrs) n.setAttribute(k, attrs[k]); parent.appendChild(n); return n; }
    var holesG = $('#erh-zholes', root), outsG = $('#erh-zouts', root), arwsG = $('#erh-zarws', root), HOLE = {}, OUT = {}, AR = {};
    Object.keys(SH).forEach(function (id) {
      var s = SH[id];
      HOLE[id] = el(holesG, 'rect', { x: s[0], y: s[1], width: s[2], height: s[3], 'class': 'zhole' });
      OUT[id] = el(outsG, 'rect', { x: s[0] + 3, y: s[1] + 3, width: s[2] - 6, height: s[3] - 6, rx: 6, 'class': 'zout' });
    });
    Object.keys(ARW).forEach(function (id) { AR[id] = el(arwsG, 'path', { d: ARW[id], 'class': 'zarw', 'marker-end': 'url(#erh-zah)' }); });
    var zpeak = $('#erh-zpeak', root), zbadge = $('#erh-zbadge', root), zlabs = $$('#erh-zlab text', root);

    /* overhead view (steps 4-6 and 8): the front half of the car from above, nose up, driver side (US) on the LEFT.
       Car body x 218-1285, middle x 751; a pass from the driver side ends at 5/8 of the width (x 885), from the
       passenger side at x 618. Windshield bands: 0 = next to the roof (bottom on screen), 1 = middle, 2 = next to the hood. */
    var TOP = {
      ws: '425,588 371,439 344,338 339,319 346,282 368,228 387,212 412,199 452,187 471,182 516,174 683,161 756,158 921,156 950,156 1086,209 1170,244 1196,267 1208,299 1186,467 1174,536 1170,554 1161,583',
      sides: ['302,694 302,609 303,467 307,426 323,436 341,497 370,606 379,645 384,671 387,692', '1228,440 1244,462 1246,698 1200,698 1200,560 1212,470'],
      cowl: '334,262 352,214 392,176 452,152 560,130 662,86 760,80 900,108 1040,150 1150,196 1206,236 1226,282 1200,290 1168,256 1100,222 1000,184 900,170 760,166 600,170 480,186 410,212 372,252 356,292',
      wsB: [[442, 594], [300, 452], [150, 310]],
      body: [218, 1285], drvEnd: 885, pasEnd: 618, mid: 751,
      wip: [[724, 158, 432, 150], [1148, 226, 692, 98]]
    };
    /* step 7, side view: the 800 x 500 side-window picture shown at x 208, y 0, scale 1.4 (fills the frame's height).
       Glass traced on the picture; a side window is about 1.5 blade widths, so each top-to-bottom pass covers 2/3 of it,
       overlapping in the middle third: the front half first, then the back half. */
    var SW = { k: 1.4, x: 208, y: 0, glass: '290,58 770,48 772,76 752,420 40,428 33,320 62,256 117,196 180,136 220,106', bands: [[33, 526], [279, 772]], y0: 44, y1: 440 };
    var tpass = $('#erh-tpass', root), tglassG = $('#erh-tglass', root), tarws = $('#erh-tarws', root), tholes = $('#erh-tholes', root), tswpass = $('#erh-tswpass', root);
    var capZ = $('#erh-zcapView', root);
    function pts(s) { return s.split(' ').map(function (q) { var a = q.split(','); return [+a[0], +a[1]]; }); }
    function spanAt(poly, y) {
      var P = pts(poly), xs = [];
      for (var i = 0; i < P.length; i++) { var a = P[i], b = P[(i + 1) % P.length]; if ((a[1] <= y && b[1] > y) || (b[1] <= y && a[1] > y)) xs.push(a[0] + (y - a[1]) * (b[0] - a[0]) / (b[1] - a[1])); }
      return xs.length ? [Math.min.apply(0, xs), Math.max.apply(0, xs)] : null;
    }
    var swX = function (v) { return SW.x + v * SW.k; }, swY = function (v) { return SW.y + v * SW.k; };
    var swPoly = SW.glass.split(' ').map(function (q) { var a = q.split(','); return swX(+a[0]).toFixed(1) + ',' + swY(+a[1]).toFixed(1); }).join(' ');
    $('#erh-pgWS', root).setAttribute('points', TOP.ws);
    $('#erh-pgIN', root).setAttribute('points', swPoly);
    TOP.sides.forEach(function (p) { el($('#erh-cpSW', root), 'polygon', { points: p }); });
    var TG = {};
    function glassOutline(id, p) { TG[id] = [el(tglassG, 'polygon', { points: p, 'class': 'tcase' }), el(tglassG, 'polygon', { points: p, 'class': 'tglass' })]; }
    glassOutline('ws', TOP.ws); glassOutline('cowl', TOP.cowl);
    var tLoaded = false;
    function topLoad() {
      if (tLoaded) return; tLoaded = true;
      $$('.tsrc', root).forEach(function (im) { var s = im.getAttribute('data-src'); if (s) im.setAttribute('href', s); });
    }
    if ('IntersectionObserver' in window) {
      var lio = new IntersectionObserver(function (es) { if (es.some(function (e) { return e.isIntersecting; })) { topLoad(); lio.disconnect(); } }, { rootMargin: '900px 0px' });
      lio.observe(stage);
    } else topLoad();
    /* a pass = a reveal rect (filled with the scraped picture, clipped to the glass) that grows along the pass, plus an arrow.
       axis 'x': grows left-right (dir 1 = from x0, -1 = from x1); axis 'y': grows top-down from y0 */
    function passRect(g, clip, x0, x1, y0, y1, axis, dir, fill, now) {
      var rr = el(g, 'rect', { x: x0, y: y0, width: axis === 'x' ? 0 : x1 - x0, height: axis === 'y' ? 0 : y1 - y0, 'class': 'tpass' + (now ? ' now' : ''), 'clip-path': 'url(#' + clip + ')', fill: fill || 'url(#erh-patClear)' });
      return { r: rr, x0: x0, x1: x1, y0: y0, y1: y1, axis: axis, dir: dir };
    }
    function setRect(P, p) {
      if (P.axis === 'x') { var w = (P.x1 - P.x0) * p; P.r.setAttribute('width', w.toFixed(1)); P.r.setAttribute('x', (P.dir < 0 ? P.x1 - w : P.x0).toFixed(1)); }
      else P.r.setAttribute('height', ((P.y1 - P.y0) * p).toFixed(1));
    }
    function arrow(g, x1, y1, x2, y2) {
      var a = el(g, 'g', { 'class': 'arw' });
      var cc = el(a, 'path', { 'class': 'tarc', d: 'M' + x1 + ',' + y1 }), l = el(a, 'path', { 'class': 'tarw', d: 'M' + x1 + ',' + y1 }), h = el(a, 'polygon', { 'class': 'thd', points: '' });
      return { c: cc, l: l, h: h, x1: x1, y1: y1, x2: x2, y2: y2, hs: 26 };
    }
    /* the arrow's tip lands exactly on (x2,y2); the head is drawn behind it, so nothing pokes past the end point */
    function setArrow(A, p) {
      var dx = A.x2 - A.x1, dy = A.y2 - A.y1, L = Math.hypot(dx, dy) || 1, ux = dx / L, uy = dy / L, s = A.hs;
      if (p <= 0.02) { A.c.setAttribute('d', 'M' + A.x1 + ',' + A.y1); A.l.setAttribute('d', 'M' + A.x1 + ',' + A.y1); A.h.setAttribute('points', ''); return; }
      var x = A.x1 + dx * p, y = A.y1 + dy * p, dd = 'M' + A.x1 + ',' + A.y1 + ' L' + (x - ux * s * 0.75).toFixed(1) + ',' + (y - uy * s * 0.75).toFixed(1);
      A.c.setAttribute('d', dd); A.l.setAttribute('d', dd);
      var bx = x - ux * s * 1.15, by = y - uy * s * 1.15;
      A.h.setAttribute('points', [[x, y], [bx - uy * s * 0.75, by + ux * s * 0.75], [bx + uy * s * 0.75, by - ux * s * 0.75]].map(function (q) { return q[0].toFixed(1) + ',' + q[1].toFixed(1); }).join(' '));
    }
    var tRAF = 0;
    function stageRender(k) {
      var s = STEPS[k], t = s.top, sw = !!s.sw;
      if (tRAF) { cancelAnimationFrame(tRAF); tRAF = 0; }
      stage.classList.toggle('is-top', !!t);
      stage.classList.toggle('is-sw', sw);
      if (capZ) capZ.textContent = t ? CAP.top : (sw ? CAP.sw : CAP.side);
      tpass.textContent = ''; tarws.textContent = ''; tholes.textContent = ''; tswpass.textContent = '';
      if (!t && !sw) return;
      topLoad();
      var P = [];
      if (sw) {
        /* step 7, side view: two passes from the top of the glass to the bottom, the front half, then the back half */
        SW.bands.forEach(function (B, i) {
          var x0 = swX(B[0]), x1 = swX(B[1]), pr = passRect(tswpass, 'erh-cpIN', x0, x1, swY(SW.y0), swY(SW.y1), 'y', 1, 'url(#erh-patSide)', 1), cx = +((x0 + x1) / 2).toFixed(1);
          var sp = [];
          for (var yy = swY(SW.y0); yy <= swY(SW.y1); yy += 2) { var q = spanAt(swPoly, yy); if (q && q[0] < cx - 14 && q[1] > cx + 14) sp.push(yy); }
          if (!sp.length) return;
          var ar = arrow(tswpass, cx, Math.round(sp[0] + 14), cx, Math.round(sp[sp.length - 1] - 10));
          P.push({ f: function (p) { setRect(pr, p); setArrow(ar, p); }, t0: 150 + i * 1100, t1: 1150 + i * 1100 });
        });
      } else {
        var band = t.band != null ? t.band : 3, holes = [], lit = [], labs = { view: 1, driver: 1, pass: 1, roof: 1 };
        /* windshield: earlier bands already scraped; this step's band animates, driver side first, then the passenger
           side. Each pass runs from its own edge of the glass to 5/8 of the car width, so the two overlap just past the middle. */
        for (var b = 0; b <= Math.min(band, 2); b++) {
          var y0 = TOP.wsB[b][0], y1 = TOP.wsB[b][1], now = (b === band), cy = (y0 + y1) / 2;
          var pd = passRect(tpass, 'erh-cpWS', TOP.body[0], TOP.drvEnd, y0, y1, 'x', 1, 0, now), pp = passRect(tpass, 'erh-cpWS', TOP.pasEnd, TOP.body[1], y0, y1, 'x', -1, 0, now);
          if (!now) { setRect(pd, 1); setRect(pp, 1); continue; }
          (function (pd, pp, cy) {
            var yd = cy - 24, yp = cy + 24, sd = spanAt(TOP.ws, yd), spp = spanAt(TOP.ws, yp);
            var ad = arrow(tarws, Math.round(sd[0] + 22), yd, TOP.drvEnd - 6, yd), ap = arrow(tarws, Math.round(spp[1] - 22), yp, TOP.pasEnd + 6, yp);
            P.push({ f: function (p) { setRect(pd, p); setArrow(ad, p); }, t0: 150, t1: 1150 }, { f: function (p) { setRect(pp, p); setArrow(ap, p); }, t0: 1250, t1: 2250 });
          })(pd, pp, cy);
        }
        if (band < 3) { holes = ['ws']; lit = ['ws']; labs.mid = 1; }
        else el(tpass, 'rect', { x: 300, y: 140, width: 940, height: 470, 'class': 'tpass', 'clip-path': 'url(#erh-cpWS)', fill: 'url(#erh-patClear)' }); /* windshield done */
        if (t.wipers) {
          holes = ['cowl']; lit = ['cowl']; labs.wipers = 1;
          el(tpass, 'rect', { x: 280, y: 400, width: 990, height: 300, 'class': 'tpass', 'clip-path': 'url(#erh-cpSW)', fill: 'url(#erh-patClear)' }); /* side windows done */
          TOP.wip.forEach(function (w, i) { var ar = arrow(tarws, w[0], w[1], w[2], w[3]); P.push({ f: function (p) { setArrow(ar, p); }, t0: 150 + i * 900, t1: 1050 + i * 900 }); });
        }
        Object.keys(TG).forEach(function (id) { var v = lit.indexOf(id) > -1; TG[id][0].classList.toggle('on', v); TG[id][1].classList.toggle('on', v); });
        holes.forEach(function (id) { el(tholes, 'polygon', { points: id === 'ws' ? TOP.ws : TOP.cowl, fill: '#000' }); });
        $('#erh-tmid', root).style.opacity = labs.mid ? 1 : 0;
        $$('#erh-tlabs > g', root).forEach(function (g) { g.style.opacity = labs[g.getAttribute('data-t')] ? 1 : 0; });
      }
      var t0 = performance.now(), END = P.reduce(function (m, q) { return Math.max(m, q.t1); }, 0);
      function frameT(nowT) {
        var e = reduce ? END : nowT - t0;
        P.forEach(function (q) { q.f(Math.max(0, Math.min(1, (e - q.t0) / (q.t1 - q.t0)))); });
        if (e < END) tRAF = requestAnimationFrame(frameT); else tRAF = 0;
      }
      frameT(t0);
    }
    /* solid dark pill behind every overlay label; rebuilt when fonts load or the size class changes */
    function pills() {
      $$('#erh-zlab .zpill, #erh-tlabs .zpill, #erh-tswlabs .zpill', root).forEach(function (rr) { rr.parentNode.removeChild(rr); });
      $$('#erh-zlab text, #erh-tlabs text, #erh-tswlabs text', root).forEach(function (tx) {
        var bb; try { bb = tx.getBBox(); } catch (e) { return; }
        if (!bb || !bb.width) return;
        var fs = parseFloat(getComputedStyle(tx).fontSize) || 26, px = fs * 0.42, py = fs * 0.24;
        var rr = d.createElementNS(NS, 'rect');
        rr.setAttribute('x', (bb.x - px).toFixed(1)); rr.setAttribute('y', (bb.y - py).toFixed(1));
        rr.setAttribute('width', (bb.width + px * 2).toFixed(1)); rr.setAttribute('height', (bb.height + py * 2).toFixed(1)); rr.setAttribute('rx', (fs * 0.22).toFixed(1));
        rr.setAttribute('class', 'zpill' + (tx.classList.contains('on') ? ' on' : ''));
        ['data-row', 'data-col'].forEach(function (a) { if (tx.hasAttribute(a)) rr.setAttribute(a, tx.getAttribute(a)); });
        tx.parentNode.insertBefore(rr, tx);
      });
    }
    pills();
    if (d.fonts && d.fonts.ready) d.fonts.ready.then(pills);
    var pillMQ = window.matchMedia('(max-width:760px)'); if (pillMQ.addEventListener) pillMQ.addEventListener('change', pills);

    var CAR = 'M3,23 V19.5 Q3.5,17.5 6,17 L9.5,16.5 L13,11.5 Q13.5,11 14.5,11 H21 Q22,11 22.6,11.6 L26,16.5 L28.5,17.2 Q29.5,17.6 29.5,19 V23 Z', GLASS = 'M9,7 H23 L27,25 H5 Z';
    var ICONS = [
      CAR + '|M17.5,8 L15.5,4.5 H19.5 Z', CAR + '|M25,15 H8 M25,20 H8', CAR + '|M17.5,8 Q11,6.5 4,12.5 M3.9,9.6 L4,12.5 L6.7,11.8', CAR + '|M17.5,8 Q24,6.5 28.5,12.5 M28.6,9.6 L28.5,12.5 L25.8,11.8',
      GLASS + '|M9.6,10.5 H22.4', GLASS + '|M8.3,16 H23.7', GLASS + '|M7,21.5 H25', 'M6,9 H21 L27,15 V24 H6 Z|M8,12.5 H21 M8,17 H24', GLASS + '|M9,23 L17,12.5',
      'M16,4 A12,12 0 1,1 15.99,4|M10.5,16.5 L14.5,20.5 L22,12'
    ];
    function iconSVG(k) {
      var p = (ICONS[k] || ICONS[0]).split('|');
      return '<svg class="sico" viewBox="0 0 32 32" aria-hidden="true"><path class="d" d="' + p[0] + '" fill="none" stroke-linecap="round" stroke-linejoin="round"/><path class="d a" d="' + p[1] + '" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    }
    var N = STEPS.length, cur = 0, timer = null, playingNow = false, userPaused = false, inView = false, STEP_MS = 2800, pbs = [];
    prog.textContent = '';
    prog.style.setProperty('--stepms', STEP_MS + 'ms');
    STEPS.forEach(function (s, k) {
      var b = d.createElement('button'); b.type = 'button';
      b.setAttribute('aria-label', (k ? 'Step ' + k + ': ' : 'Start: ') + s.t);
      b.innerHTML = iconSVG(k) + '<em></em><i></i>';
      b.querySelector('em').textContent = s.l || '';
      on(b, 'click', function () { pause(true); show(k); });
      prog.appendChild(b); pbs.push(b);
    });
    var cEl = $('#erh-counter', root), tEl = $('#erh-stepTitle', root), xEl = $('#erh-stepText', root), toolEl = $('#erh-stepTool', root);
    var prevB = $('#erh-prevB', root), nextB = $('#erh-nextB', root), playB = $('#erh-playB', root), playIco = $('#erh-playIco', root);
    function render(k) {
      cur = k; var s = STEPS[k];
      Object.keys(HOLE).forEach(function (id) { var o = s.h.indexOf(id) > -1; HOLE[id].classList.toggle('on', o); OUT[id].classList.toggle('on', o); });
      Object.keys(AR).forEach(function (id) { AR[id].classList.toggle('on', s.a.indexOf(id) > -1); });
      zpeak.style.opacity = s.peak ? 1 : 0; zbadge.classList.toggle('on', !!s.badge);
      var rows = {}, cols = {};
      s.h.forEach(function (id) {
        var m = /^r(\d)c(\d)$/.exec(id);
        if (m) { rows[m[1]] = 1; cols[m[2]] = 1; }
        else if (id === 'all') { rows[0] = rows[1] = rows[2] = 1; cols[0] = cols[1] = cols[2] = 1; }
      });
      var lab = function (t) { var rw = t.getAttribute('data-row'), cl = t.getAttribute('data-col'); t.classList.toggle('on', rw !== null ? !!rows[rw] : !!cols[cl]); };
      zlabs.forEach(lab); $$('#erh-zlab .zpill', root).forEach(lab);
      stageRender(k);
      cEl.textContent = s.c; tEl.textContent = s.t; xEl.textContent = s.x;
      toolEl.textContent = '';
      (s.tool || []).forEach(function (t, i) { var sp = d.createElement('span'); if (i === 0) sp.className = 'g'; sp.textContent = t; toolEl.appendChild(sp); });
      pbs.forEach(function (b, i) {
        b.classList.toggle('cur', i === k); b.classList.toggle('done', i < k); b.classList.remove('run');
        if (i === k) b.setAttribute('aria-current', 'step'); else b.removeAttribute('aria-current');
      });
      if (playingNow) { void pbs[k].offsetWidth; pbs[k].classList.add('run'); }
      prevB.disabled = k === 0; nextB.disabled = k === N - 1;
      if (prog.scrollWidth > prog.clientWidth + 2) { var bb = pbs[k]; prog.scrollTo({ left: bb.offsetLeft - prog.clientWidth / 2 + bb.offsetWidth / 2, behavior: behave }); }
    }
    var vtBusy = false;
    function show(k) {
      k = Math.max(0, Math.min(N - 1, k));
      if (!vtBusy && !reduce && d.startViewTransition && k !== cur && inView) {
        vtBusy = true;
        var vt = d.startViewTransition(function () { render(k); });
        vt.finished.then(function () { vtBusy = false; }, function () { vtBusy = false; });
      } else render(k);
    }
    function setPlayUI(isOn) {
      var end = !isOn && cur >= N - 1;
      playIco.setAttribute('d', isOn ? 'M6.5,4.5 H10 V19.5 H6.5 Z M14,4.5 H17.5 V19.5 H14 Z' : (end ? 'M12,5 A7,7 0 1,1 5.2,10.3 M5,4.5 V10.5 H11' : 'M7,4.5 L19.5,12 L7,19.5 Z'));
      playIco.setAttribute('fill', end ? 'none' : 'currentColor');
      playIco.setAttribute('stroke', end ? 'currentColor' : 'none'); playIco.setAttribute('stroke-width', '2.6'); playIco.setAttribute('stroke-linecap', 'round');
      playB.setAttribute('aria-label', isOn ? 'Pause' : (cur >= N - 1 ? 'Replay the steps' : 'Play the steps'));
    }
    function tick() {
      if (cur >= N - 1) { pause(false); setPlayUI(false); return; }
      show(cur + 1); timer = setTimeout(tick, STEP_MS);
    }
    function play() {
      if (playingNow) return;
      if (cur >= N - 1) render(0);
      playingNow = true; userPaused = false; setPlayUI(true);
      pbs[cur].classList.remove('run'); void pbs[cur].offsetWidth; pbs[cur].classList.add('run');
      timer = setTimeout(tick, STEP_MS);
    }
    function pause(byUser) {
      if (timer) { clearTimeout(timer); timer = null; }
      playingNow = false; if (byUser) userPaused = true;
      pbs.forEach(function (b) { b.classList.remove('run'); });
      setPlayUI(false);
    }
    on(playB, 'click', function () { if (playingNow) pause(true); else play(); });
    on(prevB, 'click', function () { pause(true); show(cur - 1); });
    on(nextB, 'click', function () { pause(true); show(cur + 1); });
    on(stage, 'click', function () { if (playingNow) pause(true); else play(); });
    on(stage, 'keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); pause(true); show(cur + 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); pause(true); show(cur - 1); }
      else if (e.key === ' ' || e.key === 'k') { e.preventDefault(); if (playingNow) pause(true); else play(); }
    });
    var sx = 0, sy = 0;
    on(stage, 'touchstart', function (e) { var t = e.changedTouches[0]; sx = t.clientX; sy = t.clientY; }, { passive: true });
    on(stage, 'touchend', function (e) {
      var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { e.preventDefault(); pause(true); show(cur + (dx < 0 ? 1 : -1)); }
    });
    /* autoplay when the player is mostly in view (never on reduced motion, never after the visitor paused);
       it pauses when it leaves the screen or the tab is hidden */
    if ('IntersectionObserver' in window) {
      var zio = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          inView = en.isIntersecting && en.intersectionRatio >= 0.6;
          if (inView && !d.hidden) { if (!reduce && !userPaused && !playingNow && cur < N - 1) play(); }
          else if (playingNow) pause(false);
        });
      }, { threshold: [0, 0.6, 1] });
      zio.observe(stage);
    }
    on(d, 'visibilitychange', function () { if (d.hidden && playingNow) pause(false); });
    root.__erhStop = function () { pause(false); if (tRAF) cancelAnimationFrame(tRAF); };
    render(0); setPlayUI(false);
  }

  /* ================= more uses: tap a card to open it ================= */
  function initUses(root) {
    $$('.ucard', root).forEach(function (b) {
      on(b, 'click', function () {
        var o = b.getAttribute('aria-expanded') !== 'true';
        b.setAttribute('aria-expanded', o ? 'true' : 'false');
        var ic = b.querySelector('.ico');
        if (o && ic && !reduce) { ic.classList.remove('in'); void ic.getBoundingClientRect(); ic.classList.add('in'); }
      });
    });
  }

  /* ---------- set up every How-to section on the page (and any the theme editor reloads) ---------- */
  var INIT = { parts: initParts, holds: initHolds, order: initOrder, uses: initUses };
  function setup(root) {
    if (!root || root.__erh) return;
    root.__erh = true;
    if (offIO) offIO.observe(root);
    collect(root);
    var fn = INIT[root.getAttribute('data-erh')];
    if (fn) { try { fn(root); } catch (e) { if (window.console) console.error('edge-r-howto', e); } }
  }
  function setupAll() { $$('.edge-r-howto[data-erh]').forEach(setup); }

  var ticking = false;
  function frame() { ticking = false; setTop(); sweep(false); chapterPos(); }
  function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(frame); } }

  setTop();
  setupAll();
  sweep(true);
  chapterPos();
  on(window, 'scroll', onScroll, { passive: true });
  on(window, 'resize', frame);
  on(window, 'load', frame);
  on(d, 'shopify:section:load', function (e) { var r = e.target && e.target.querySelector && e.target.querySelector('.edge-r-howto[data-erh]'); if (r) { setup(r); sweep(true); chapterPos(); } });
  on(d, 'shopify:section:unload', function (e) { var r = e.target && e.target.querySelector && e.target.querySelector('.edge-r-howto[data-erh]'); if (r && r.__erhStop) r.__erhStop(); });

  window.EdgeRHowto = { version: 'pass7-2026-10-05' };
})();
